export enum WREX_QUOTE {
    /**
     * Lokalize link: https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=139817001
     */
    QUOTE_BLOCK_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.QUOTE_BLOCK_BUTTON',
}
